import React, { useState, useEffect } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { ApiUrl, Headers } from '../services/ApiUrl'
import { useUserStore } from '../stores/UserStore'
import { Container, Row, Col, Card, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios'
import HeroVotar from './VotarHero';

const PanelVotanteLink = () => {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const userGlobal = useUserStore((state) => state.userGlobal);
    const updateUser = useUserStore((state) => state.updateUser);

    useEffect(() => {
        const dni = searchParams.get('dni');
        const codigo = searchParams.get('codigo');

        if (!dni || !codigo) {
            setError('El link es inválido o ha expirado. Por favor, solicite un nuevo link de votación.');
            setLoading(false);
            return;
        }

        validarCodigo(dni, codigo);
    }, [searchParams]);

    const validarCodigo = async (dni, codigo) => {
        try {
            const response = await axios.post(`${ApiUrl}registrarvotolink`, {
                dni: dni,
                codigo: codigo
            }, { headers: Headers });

            if (response.data.error === true) {
                setError(response.data.mensaje);
                setLoading(false);
                return;
            }

            // Si todo está bien, actualizamos el estado global
            const newUser = {
                error: false,
                login: true,
                id_user: response.data.id_votante,
                isVoted: false,
                codigo_confirm: response.data.codigo_confirm,
                name_user: response.data.nombre_apellido_votante,
                dni: dni,
                errorMsg: ""
            };
            
            updateUser(newUser);

        } catch (error) {
            setError('Error de conexión. Por favor, intente más tarde o utilice el formulario de votación.');
            setLoading(false);
        }
    };

    // Si el usuario ya está logueado, redirigimos a propuestas
    if (userGlobal.login === true) {
        return <Navigate to="/propuestas" />;
    }

    return (
        <>
            {!userGlobal.login &&
                <>
                    <HeroVotar />

                    <Container className="mt-4">
                        <Row>
                            <Col>
                                <Card className="mb-4">
                                    <Card.Header className="text-white" style={{ backgroundColor: '#143c2c' }}>
                                        <i className="bi bi-link-45deg me-2"></i>
                                        Acceso para Votación
                                    </Card.Header>
                                    <Card.Body>
                                        {loading ? (
                                            <div className="text-center p-5">
                                                <Spinner animation="border" variant="success" />
                                                <p className="mt-3">Validando datos de acceso...</p>
                                            </div>
                                        ) : error ? (
                                            <Alert variant="danger">
                                                <Alert.Heading>No se pudo iniciar la sesión</Alert.Heading>
                                                <p>{error}</p>
                                                <hr />
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <p className="mb-0">
                                                        Puede intentar votar usando el formulario de registro.
                                                    </p>
                                                    <a href="/" className="btn btn-outline-success">
                                                        Ir al formulario de votación
                                                    </a>
                                                </div>
                                            </Alert>
                                        ) : (
                                            <div className="text-center">
                                                <Spinner animation="border" variant="success" />
                                                <p className="mt-3">Iniciando sesión...</p>
                                            </div>
                                        )}
                                    </Card.Body>
                                </Card>

                                {!loading && error && (
                                    <Card className="mt-4">
                                        <Card.Body>
                                            <h5>¿Necesita ayuda?</h5>
                                            <p>
                                                Si está teniendo problemas para votar, puede:
                                            </p>
                                            <ul>
                                                <li>Verificar que el link sea el último que recibió por correo</li>
                                                <li>Intentar votar usando el formulario principal de votación</li>
                                                <li>Solicitar un nuevo código de votación</li>
                                            </ul>
                                        </Card.Body>
                                    </Card>
                                )}
                            </Col>
                        </Row>
                    </Container>
                </>
            }
        </>
    );
};

export default PanelVotanteLink;